// extracted by mini-css-extract-plugin
export var messageSideLeft = "_jv-1";
export var messageSideRight = "_jv-2";
export var orderLookupBubbleContainer = "_jv-0";
export var submitButton = "_jv-3";